<div>
	<div fxLayout="row" fxLayoutGap="1rem">
		<div
			fxFlex.gt-lg="{{ showPickupDate ? 22 : 33 }}"
			fxFlex.gt-md="{{ showPickupDate ? 19 : 33 }}"
			fxFlex.gt-xs="{{ showPickupDate ? 19 : 33 }}"
			fxLayoutAlign="center center"
		>
			<mat-form-field fxFlex="100" class="{{ customFormFieldClass }}">
				<mat-label class="{{ placeholderRequiredClass }}">Origin (city, state, country)</mat-label>
				<input
					#LocationCtrl="ngModel"
					#originInput
					(setAddress)="getAddressOnChange($event, 'origin')"
					[(ngModel)]="origin"
					[allowStateSelection]="allowStateSelection"
					[disabled]="isEditQuote"
					appGoogleLocation
					matInput
					name="origin"
					placeholder=""
					[required]="isOriginRequired"
					type="text"
					[ngStyle]="{ color: isOriginCityMissing ? 'Red' : 'black' }"
				/>
			</mat-form-field>
		</div>

		<div
			*ngIf="useSearch"
			fxFlex.gt-lg="4"
			fxFlex.gt-md="{{ showPickupDate ? 3 : 3 }}"
			fxFlex.gt-xs="{{ showPickupDate ? 3 : 3 }}"
			fxLayoutAlign="center center"
		>
			<mat-icon
				(click)="animate(); swapLocations()"
				class="primary-light-color"
				matPrefix
				style="cursor: pointer"
			>
				swap_horiz
			</mat-icon>
		</div>

		<div
			fxFlex.gt-lg="{{ showPickupDate ? 22 : 33 }}"
			fxFlex.gt-md="{{ showPickupDate ? 19 : 33 }}"
			fxFlex.gt-xs="{{ showPickupDate ? 19 : 33 }}"
			fxLayoutAlign="center center"
		>
			<mat-form-field fxFlex="100" class="{{ customFormFieldClass }}">
				<mat-label class="{{ placeholderRequiredClass }}"
					>Destination (city, state, country)</mat-label
				>
				<input
					#LocationCtrl="ngModel"
					#destinationInput
					(setAddress)="getAddressOnChange($event, 'destination')"
					[(ngModel)]="destination"
					[allowStateSelection]="allowStateSelection"
					[disabled]="isEditQuote"
					appGoogleLocation
					matInput
					name="destination"
					placeholder=""
					[required]="isDestinationRequired"
					type="text"
					[ngStyle]="{ color: isDestinationCityMissing ? 'Red' : 'black' }"
				/>
			</mat-form-field>
		</div>

		<div
			*ngIf="!multipleTrailerTypes"
			class="single-trailer-type"
			fxFlex.gt-md="{{ useSearch ? 19 : 33 }}"
			fxFlex.gt-sm="{{ useSearch ? 19 : 33 }}"
			fxFlex.gt-xs="15"
			fxFlex.lg="{{ useSearch ? 20 : 33 }}"
			fxLayoutAlign="center center"
		>
			<mat-form-field fxFlex="100" class="{{ customFormFieldClass }}">
				<mat-label class="{{ placeholderRequiredClass }}"
					>Trailer type {{ isTrailerTypesRequired ? '*' : '' }}</mat-label
				>
				<mat-select
					(selectionChange)="syncData()"
					[(ngModel)]="searchTruckForm.trailerType"
					[disabled]="isEditQuote"
					[compareWith]="compareEquipment"
				>
					<mat-option *ngFor="let trailer of trailerTypes" [value]="trailer.dbVal">
						{{ trailer.value }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>

		<div
			*ngIf="multipleTrailerTypes"
			class="multiple-trailer-types"
			fxFlex.gt-lg="{{ useSearch ? 21 : 33 }}"
			fxFlex.gt-md="{{ useSearch ? 19 : 33 }}"
			fxFlex.gt-sm="{{ useSearch ? 19 : 33 }}"
			fxFlex.gt-xs="15"
			fxFlex.lg="{{ useSearch ? 20 : 33 }}"
			fxLayoutAlign="center center"
		>
			<mat-form-field fxFlex="100" class="{{ customFormFieldClass }}">
				<mat-label class="{{ placeholderRequiredClass }}"
					>Trailer types {{ isTrailerTypesRequired ? '*' : '' }}</mat-label
				>
				<mat-select
					#trailerType
					(keypress)="detect($event.key)"
					(selectionChange)="syncData()"
					[(value)]="searchTruckForm.trailerType"
					[compareWith]="compareEquipment"
					[disabled]="isEditQuote"
					multiple
				>
					<mat-option *ngFor="let trailer of trailerTypes" [value]="trailer.dbVal">
						{{ trailer.value }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>

		<div
			*ngIf="showPickupDate && !useSearch && !useDaterange"
			class="single-date-selector"
			fxFlex.gt-md="{{ useSearch ? 19 : 25 }}"
			fxFlex.gt-sm="{{ useSearch ? 19 : 25 }}"
			fxFlex.gt-xs="15"
			fxFlex.lg="{{ useSearch ? 20 : 25 }}"
			fxLayoutAlign="center center"
		>
			<mat-form-field fxFlex="100" class="{{ customFormFieldClass }}">
				<input
					(click)="picker1.open()"
					(dateChange)="syncData()"
					[formControl]="searchTruckForm.pickupDate"
					[matDatepicker]="picker1"
					[min]="minimumPickupDate"
					matInput
					placeholder="Pickup Date"
				/>
				<mat-datepicker-toggle [for]="picker1" matSuffix tabIndex="-1"></mat-datepicker-toggle>
				<mat-datepicker #picker1></mat-datepicker>
			</mat-form-field>
		</div>

		<div
			*ngIf="useSearch || useDaterange"
			class="date-range-selector"
			fxFlex.gt-lg="{{ useSearch ? 21 : 33 }}"
			fxFlex.gt-md="{{ useSearch ? 19 : 25 }}"
			fxFlex.gt-sm="{{ useSearch ? 19 : 25 }}"
			fxFlex.gt-xs="15"
			fxFlex.lg="{{ useSearch ? 20 : 25 }}"
			fxLayoutAlign="center center"
		>
			<app-date-range-selector
				(dateSelected)="dateRangeUpdated($event)"
				[dateLimit]="30"
				[initialPickupEndDate]="initialPickupDateRange.end"
				[initialPickupStartDate]="initialPickupDateRange.start"
			>
			</app-date-range-selector>
		</div>

		<div
			*ngIf="useSearch"
			fxFlex.gt-lg="12"
			fxFlex.gt-md="24"
			fxFlex.gt-sm="12"
			fxFlex.gt-xs="40"
			fxFlex.lg="10"
		>
			<div fxLayoutAlign="end start">
				<button (click)="searchTrucks()" class="primary-light" mat-mini-fab matSuffix>
					<mat-icon>search</mat-icon>
				</button>
			</div>

			<div
				*ngIf="useSearch && productsService.PRICING"
				class="my-2"
				fxLayoutAlign="end start"
				ngClass.lt-xl="advamcedSearch"
			>
				<div *ngIf="IS_ADVANCED_OPTIONS_ENABLED" fxLayoutAlign="end center">
					<span (click)="togglePricingOptions()" class="cursor-pointer label-color"
						>Advanced Options</span
					>
					<span (click)="togglePricingOptions()" class="cursor-pointer">
						<mat-icon *ngIf="!showPricingOptions">keyboard_arrow_down</mat-icon>
						<mat-icon *ngIf="showPricingOptions">keyboard_arrow_up</mat-icon>
					</span>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="showPricingOptions" [@enter] [@leave]>
		<div class="p-b-0-2" fxLayout="row">
			<div fxFlex="100">
				<div fxLayout="row wrap" fxLayoutGap="0.5rem">
					<mat-checkbox
						*ngIf="IS_HAZMAT_ENABLED"
						[(ngModel)]="searchTruckForm.hazmat"
						color="primary"
						fxFlex="15"
						labelPosition="after"
						>Hazmat
					</mat-checkbox>
					<mat-checkbox
						*ngIf="IS_TEAMS_CAPACITY_ENABLED"
						[(ngModel)]="searchTruckForm.hasTeams"
						color="primary"
						fxFlex="15"
						labelPosition="after"
						>Has Teams
					</mat-checkbox>
				</div>
			</div>
		</div>
	</div>
</div>
